import { Logo } from "./Logo";

export const Footer = () => {
  const go = (target) => {
    const el = document.querySelector(target);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -20, duration: 1.4 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="relative bg-[#0a0a0f] border-t border-white/5 pt-24 md:pt-32 pb-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-20">
          <div className="md:col-span-6">
            <Logo markSize={44} testId="footer-logo" />
            <p className="font-display text-2xl sm:text-3xl text-[#f8f9fa] font-light tracking-tight mt-10 max-w-md leading-snug">
              Premium Accounting.
              <span className="text-[#c9a84c] italic"> Exceptional Results.</span>
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-body text-xs tracking-[0.3em] uppercase text-[#9ba1a6] mb-6">Explore</p>
            <ul className="space-y-4">
              {[
                { l: "About", t: "#about" },
                { l: "Services", t: "#services" },
                { l: "Why Us", t: "#why" },
                { l: "Contact", t: "#contact" },
              ].map((i) => (
                <li key={i.t}>
                  <button
                    onClick={() => go(i.t)}
                    data-testid={`footer-link-${i.l.toLowerCase().replace(" ", "-")}`}
                    className="font-body text-sm text-[#c9c9cf] hover:text-[#c9a84c] transition-colors duration-300"
                  >
                    {i.l}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-body text-xs tracking-[0.3em] uppercase text-[#9ba1a6] mb-6">Contact</p>
            <ul className="space-y-4 font-body text-sm text-[#c9c9cf]">
              <li><a href="tel:+61459646667" className="hover:text-[#c9a84c] transition-colors">0459 646 667</a></li>
              <li><a href="mailto:Eddy@theaccountantgroup.com.au" className="hover:text-[#c9a84c] transition-colors">Eddy@theaccountantgroup.com.au</a></li>
              <li>Bankstown, NSW · Australia-wide</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-10 flex flex-col md:flex-row md:items-center justify-between gap-6">
          <p className="font-body text-xs text-[#6a6f75]">
            © {new Date().getFullYear()} The Accountant Pty Ltd · ABN: 30 658 829 719
          </p>
          <p className="font-body text-xs text-[#6a6f75] max-w-lg md:text-right">
            General advice only. For personalised advice please contact us.
          </p>
        </div>
      </div>
    </footer>
  );
};
